import * as actionTypes from './actionTypes';
import { I_Recommend } from './reducer';

interface I_RecommendReq {
    Type: string;
    Country: string;
    ArriveID: string;
    GoDateStart?: string;
    GoDateEnd?: string;
    TourSource: string;
}

export interface I_RecommendsSyncAction {
    type: typeof actionTypes.SET_RECOMMENDS_SYNC;
    payload: any;
}

export const setRecommends = (payload: I_RecommendReq) => ({
    type: actionTypes.SET_RECOMMENDS,
    payload,
});

export const setRecommendsSUCCESS = (payload: I_Recommend) => ({
    type: actionTypes.SET_RECOMMENDS_SUCCESS,
    payload,
});

export const removeRecommendAction = (index: number) => ({
    type: actionTypes.REMOVE_RECOMMEND,
    index,
});

export type I_RecommendAction = ReturnType<typeof setRecommends>;
